import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { Button } from '@carnica/ui-kit';
import { tariff } from "../../../constants/tariff";
import { selectMobileConnectionAccumulators, selectTariffUrl } from "../store";
import { Accumulator } from "../Accumulator";
import styles from "./styles.pcss";
import { getUnit } from "../Accumulator/utils";
import { ANALYTICS_ACTION, ANALYTICS_ITEM_TYPE } from "../../../constants/analytics";
import { pushFubAnalytics } from "../../../utils/analytics";
import { selectAccountType, selectIsSvyazZ } from "../../../store/selectors";
var cn = classNames.bind(styles);
var _Accumulators = function _Accumulators(_ref) {
  var accumulators = _ref.accumulators,
    tariffUrl = _ref.tariffUrl,
    isSvyazZ = _ref.isSvyazZ,
    target = _ref.target,
    userType = _ref.userType;
  var evenList = !(accumulators.length % 2) ? accumulators : accumulators.slice(0, -1);
  var lastElement = !(accumulators.length % 2) ? null : accumulators[accumulators.length - 1];
  var handleManageTariffClick = function handleManageTariffClick(e) {
    e.preventDefault();
    pushFubAnalytics(target, {
      account_type: userType,
      action: ANALYTICS_ACTION.CLICK,
      item_type: ANALYTICS_ITEM_TYPE.BUTTON,
      button_text: tariff.manage.btnTitle
    });
    window.location.href = tariffUrl;
  };
  if (!accumulators.length) {
    return /*#__PURE__*/React.createElement(Button, {
      onClick: handleManageTariffClick,
      size: "l",
      type: "button",
      view: "tertiary",
      width: "full",
      "data-t-id": "MobileTariff-Accumulators"
    }, tariff.manage.btnTitle);
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('wrap')
  }, evenList.map(function (accumulator) {
    return /*#__PURE__*/React.createElement("li", {
      className: cn('accumulator'),
      key: accumulator.unit
    }, /*#__PURE__*/React.createElement(Accumulator, {
      isLow: accumulator.isLow,
      isSvyazZ: isSvyazZ,
      isUnlimited: accumulator.isUnlimited,
      replenishButtonType: accumulator === null || accumulator === void 0 ? void 0 : accumulator.replenishButtonType,
      rest: accumulator.rest,
      size: accumulator.size,
      target: target,
      tariffUrl: tariffUrl,
      unit: getUnit((accumulator === null || accumulator === void 0 ? void 0 : accumulator.displayUnit) || ''),
      userType: userType
    }));
  }), !!lastElement && /*#__PURE__*/React.createElement("li", {
    className: cn('accumulator'),
    key: lastElement.unit
  }, /*#__PURE__*/React.createElement(Accumulator, {
    isLast: lastElement && accumulators.length > 1,
    isLow: lastElement.isLow,
    isSvyazZ: isSvyazZ,
    isUnlimited: lastElement.isUnlimited,
    replenishButtonType: lastElement === null || lastElement === void 0 ? void 0 : lastElement.replenishButtonType,
    rest: lastElement.rest,
    size: lastElement.size,
    target: target,
    tariffUrl: tariffUrl,
    unit: getUnit((lastElement === null || lastElement === void 0 ? void 0 : lastElement.displayUnit) || ''),
    userType: userType
  })));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    accumulators: selectMobileConnectionAccumulators(state),
    tariffUrl: selectTariffUrl(state),
    isSvyazZ: selectIsSvyazZ(state),
    userType: selectAccountType(state)
  };
};
var connector = connect(mapStateToProps);
export var Accumulators = connector(_Accumulators);